import { from, interval, EMPTY } from "rxjs";
import { map, distinctUntilChanged, switchMap, catchError } from "rxjs/operators";
import { clientApi } from '../apis/clientApi';

const role$ = (store) => from(store).pipe(
    map((state) => state.auth.Role),
    distinctUntilChanged()
);

export const monitorClientRole = (store) => {
    role$(store).pipe(
        switchMap((role) => {
            if (role === 'Free_User' || role === 'Pro_User') {
                return interval(30000).pipe(
                    switchMap(() => {
                        store.dispatch(clientApi.endpoints.refreshData.initiate());
                        return EMPTY;
                    })
                );
            }
            return EMPTY;
        }),
        catchError(() => EMPTY)
    ).subscribe();
};
